import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/OptionsMenu/options-menu';
import { DropdownContext } from '../Dropdown';
import { DropdownWithContext } from '../Dropdown/DropdownWithContext';
export var OptionsMenuPosition;

(function (OptionsMenuPosition) {
  OptionsMenuPosition["right"] = "right";
  OptionsMenuPosition["left"] = "left";
})(OptionsMenuPosition || (OptionsMenuPosition = {}));

export var OptionsMenuDirection;

(function (OptionsMenuDirection) {
  OptionsMenuDirection["up"] = "up";
  OptionsMenuDirection["down"] = "down";
})(OptionsMenuDirection || (OptionsMenuDirection = {}));

export var OptionsMenu = function OptionsMenu(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      menuItems = _a.menuItems,
      toggle = _a.toggle,
      _a$isText = _a.isText,
      isText = _a$isText === void 0 ? false : _a$isText,
      _a$isGrouped = _a.isGrouped,
      isGrouped = _a$isGrouped === void 0 ? false : _a$isGrouped,
      id = _a.id,
      ref = _a.ref,
      props = __rest(_a, ["className", "menuItems", "toggle", "isText", "isGrouped", "id", "ref"]);

  return React.createElement(DropdownContext.Provider, {
    value: {
      id: id,
      onSelect: function onSelect() {
        return undefined;
      },
      toggleIndicatorClass: styles.optionsMenuToggleIcon,
      toggleTextClass: styles.optionsMenuToggleText,
      menuClass: styles.optionsMenuMenu,
      itemClass: styles.optionsMenuMenuItem,
      toggleClass: isText ? styles.optionsMenuToggleButton : styles.optionsMenuToggle,
      baseClass: styles.optionsMenu,
      disabledClass: styles.modifiers.disabled,
      menuComponent: isGrouped ? 'div' : 'ul',
      baseComponent: 'div'
    }
  }, React.createElement(DropdownWithContext, Object.assign({}, props, {
    id: id,
    dropdownItems: menuItems,
    className: className,
    isGrouped: isGrouped,
    toggle: toggle
  })));
};